// audio-surface.ts — which pages may play the campaign's own audio.
//
// Encounter ambience (bed + wind), encounter/campaign music, and sound pushed from OTHER people's rolls and
// actions belong to the FT3D system (owner 2026-09-29): my_campaign.php, the DAFT3D scene host and the
// item.php campaign/PC-sheet route — every route that mounts the FT3D HUD (includes/sidepanels/ft3d_hud.php,
// [data-ft3d-hud]). Every other page (account, campaign admin tools like my_campaign_players.php, the catalog)
// still carries the soundboard decks for MANUAL playback, and the viewer's OWN rolls still make sound there,
// but nothing campaign-driven may start on its own — before this, the first click on such a page (kicking a
// player) unlocked autoplay and the ambience/music resync began playing the last active encounter's tracks.
//
// Read the DOM marker, not only the class: ft3d-hud/index.ts adds .ft3d-hud-active from its own bundle,
// and this must answer correctly whichever bundle evaluates first.
export function ftCampaignAudioSurface(): boolean {
    return document.documentElement.classList.contains('ft3d-hud-active')
        || !!document.querySelector('[data-ft3d-hud]');
}

/** Embedded campaign scenes play through their same-origin audio owner. */
export function embeddedCampaignAudioSuppressed(): boolean {
    try {
        const params = new URLSearchParams(window.location.search);
        return params.get('ft3d_campaign_view') === '1' || params.get('ft3d_embed') === '1';
    }
    catch { return false; }
}

/** True when this user created the roll/row (`<prefix>_created_by_id` against the page's boot user). */
export function ftIsViewersOwn(createdById: unknown): boolean {
    const own = String((window as unknown as { FateTide?: { user?: { id?: unknown } } }).FateTide?.user?.id ?? '').trim();
    const by = String(createdById ?? '').trim();
    return own !== '' && by !== '' && own.toUpperCase() === by.toUpperCase();
}
